import { create } from 'zustand';
import api from '../services/api';

export const useAuthStore = create((set) => ({
  user: null,
  isAuthenticated: false,
  loading: true,

  checkAuth: async () => {
    try {
      set({ loading: true });
      const response = await api.get('/loggedin');
      if (response.data && response.data._id) {
        set({ user: response.data, isAuthenticated: true, loading: false });
      } else {
        set({ user: null, isAuthenticated: false, loading: false });
      }
    } catch (error) {
      set({ user: null, isAuthenticated: false, loading: false });
    }
  },

  login: (user) => {
    set({ user, isAuthenticated: true, loading: false });
  },

  logout: async () => {
    try {
      await api.get('/logout');
    } catch (err) {
      console.error('Logout failed:', err);
    } finally {
      set({ user: null, isAuthenticated: false, loading: false });
    }
  }
}));
